import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import PaperclipWidget from "@/apps/PaperclipWidget/components/PaperclipWidget.vue";
import Vuex from "vuex";
import {root} from "@/shared/store";
import {PaperclipWidgetState} from "@/apps/PaperclipWidget/models/paperclip-widget-state";
import mutations from "@/apps/PaperclipWidget/store/mutations";
import getters from "@/apps/PaperclipWidget/store/getters";
import {getAttributeValue} from "@/shared/filters/utils-filter";

Vue.config.productionTip = false
Vue.use(VueCompositionAPI)

let widget = document.querySelectorAll('widget-paperclip')
if (widget.length) {
    widget.forEach(element => {

        let store = new Vuex.Store({
            state: new PaperclipWidgetState(),
            mutations: mutations,
            getters: getters,
            modules: {
                root
            }
        })

        new Vue({
            el: element,
            store,
            render(h: any) {
                return h(PaperclipWidget, {
                    props: {
                        config: {
                            url: getAttributeValue(element, 'url', false),
                            message: getAttributeValue(element, 'message', false),
                            linktext: getAttributeValue(element, 'linktext', false),
                        }
                    }
                })
            }
        })
    })
}
